/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ShieldUserLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M3.78 2.83 12 1l8.22 1.83c.45.1.78.5.78.97v9.99a6 6 0 0 1-2.67 5L12 23l-6.33-4.22a6 6 0 0 1-2.67-5V3.8a1 1 0 0 1 .78-.97M5 4.6v9.19a4 4 0 0 0 1.78 3.33L12 20.6l5.22-3.48A4 4 0 0 0 19 13.79V4.6l-7-1.55zm7 6.4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m-4.47 5a4.5 4.5 0 0 1 8.94 0z" />
  </Icon>
);
